import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetblogsformodal(BlogId) {
  return useQuery(
    ['get-blog-data-modal', BlogId],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.ADMIN_BLOG, {
          id: BlogId,
        })
      );

      return response.data;
    },
    {
      enabled: !!BlogId,
    }
  );
}
